export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-interpolate/src/number.js
// module id = ../../../../d3-interpolate/src/number.js
// module chunks = 4